import React from 'react';
import { Link } from 'react-router-dom';
import SpinnerLoader from './../spinnerLoader/spinnerLoader';
import _ from 'lodash';
import CONST from './../../util/const'
import './css/index.scss';


class Artists extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      letter: null
    };
  }

  componentDidMount(){
    window.scrollTo(0, 0);
    this.setState({letter: this.props.match.params.letter}, () => {
      this.props.getArtistsByLetter(this.props.match.params.letter);
    });
  }

  componentWillMount(){
    if(this.props.match.params.letter !== 'nl' && this.props.match.params.letter.length > 1)
    {
      window.location = '/';
    }

    if(!_.includes(CONST.letters, this.props.match.params.letter))
    {
      window.location = '/';
    }
  }

  componentDidUpdate(){
    if(this.props.match.params.letter !== this.state.letter)
    {
      this.setState({letter: this.props.match.params.letter}, () => {
        window.scrollTo(0, 0);
        this.props.getArtistsByLetter(this.props.match.params.letter);
      });
    }
  }

  componentWillUnmount(){
    this.props.clearArtistsByLetter();
  }

  render () {
    return (
      <div className="artistsContainer">
        <div className="mainHeader"></div>
        <div className="container">
          <div className="article" style={{ marginTop: '-200px'}}>
            <h1>{this.props.match.params.letter !== 'nl' ? `Artiști cu litera ${_.capitalize(this.props.match.params.letter)}` : `Artiști diverși`}</h1>
            {this.props.artistsByLetter !== null ? 
            (
                <div>
                  {this.props.artistsByLetter.list.length > 0 ? 
                   (<div>
                     {this.props.artistsByLetter.list.map((artist) => {
                       return <Link key={`aLli${artist.id}`} className="regularLink" to={`/artist/${artist.slug}`}>{artist.name}</Link>;
                     })}
                   </div>)
                   :
                    (<div style={{lineHeight: '22px'}}>Din păcate nu sunt artiști disponibile cu această literă. <br/> Poți contribui cu o tabulatură a unui artist cu această literă <Link className="regularLinkB" to={`/adauga-tabulatura`}>aici</Link>.</div>)
                  }
                </div>
            )
            :
            (<SpinnerLoader />)}
          </div>
        </div>
      </div>
    );
  }
}

export default Artists;



// WEBPACK FOOTER //
// ./src/components/artists/artists.js